// extracted by mini-css-extract-plugin
export default {"searchBarContainer":"SearchBar_searchBarContainer__AEmgR","searchIcon":"SearchBar_searchIcon__QhQBu","searchBar":"SearchBar_searchBar__rjQkX","xButton":"SearchBar_xButton__gVj7z"};